import Cookie from "js-cookie";

export default class Service {
  static getAPI = () => process.env.REACT_APP_API_CALC_URL+'/'+process.env.REACT_APP_API_VERSION;
  static getAPIData = () => process.env.REACT_APP_API_URL+'/'+process.env.REACT_APP_API_VERSION;
  static getAPIAi=() =>process.env.REACT_APP_API_AI_URL
  static getAPICrons = () => process.env.REACT_APP_API_CRONS_URL+'/'+process.env.REACT_APP_API_VERSION;
  static token = () => process.env.REACT_APP_PROJECT_TYPE !== 'stage' ? Cookie.get("aTkn") : "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJDb2RVc3VhcmlvIjoiYTJlOTczNDQtMDdmNi00MmU4LTkyMmMtMTA2ZWNiMzc0MmIyIiwicGVybWlzc2lvbnMiOnsiaWFUaWVyIjoiYmV0YSIsImlhRW5hYmxlZCI6dHJ1ZSwiYWRtaW4iOnRydWV9LCJ2ZXJpZmllZCI6dHJ1ZSwiaWF0IjoxNzgxNTU0MDM1LCJleHAiOjE4NzYxNjIwMzV9.Y9K6GAQeLBQ15bwLQaW_M1DWvBDKJfIQJEKkxU7EIqk";
  static redirectToProjects = () => {
    window.location.assign(`${process.env.REACT_APP_LOGIN_URL}/#/auth`);
  }
  static deviceId = () => Cookie.get("deviceId")
  static getHeadersPOST = () =>(
    { // POST and PATCH headers
      Authorization: `Bearer ${Service.token()}`,
      "Content-Type": "application/json",
      deviceid: Service.deviceId()
    }
  )
}

export class Response {
  public response: object;
}
